import { useDispatch, useSelector } from "react-redux"
import { useLocation } from "react-router-dom"
import { showModal } from "../../../features/modal/modalSlice"
import { useEffect, useState } from "react"
import { useScrollLock } from "../../../hooks/useScrollLock"
import styled from "styled-components"
import PageTopTitle from "../../shared/PageTopTitle"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import Btn from "../../shared/button/Btn"
import { BsCheckLg } from "react-icons/bs";
import { addClaims, getAllClaims, getUserClaims } from "../../../features/companyProfile/companyAuthorizationSlice"
import SmallSpinner from "../../shared/spinners/SmallSpinner"

const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 700px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .content{
            padding: 40px;
            width: 100%;
            display: flex;
            flex-direction: column;
            max-height: 500px;
            overflow: auto;

            .menu-list-container{
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                .menu-list{
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    gap: 20px;
                    .menu-item{
                        width: 100%;
                        .menu-item-title{
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            gap: 20px;
                            background-color: ${({ theme }) => theme.secondaryBgColor};
                            padding: 10px;
                            border-radius: 5px;
                            cursor: pointer;
                            span{
                                font-size: var(--font-size-md);
                                font-weight: var(--font-weight-lg);
                            }
                            .check-container{
                                display: flex;
                                align-items: center;
                                gap: 20px;
                                .title-check{
                                    display: flex;
                                    justify-content: center;
                                    align-items: center;
                                    width: 30px;
                                    height: 30px;
                                    background-color: ${({ theme }) => theme.mainBgColor};
                                    border-radius: 50%;
                                    color: ${({ theme }) => theme.mainTextColor};
                                }
                            }
                        }
                        .menu-item-content{
                            display: flex;
                            flex-direction: column;
                            padding-inline: 10px;
                            .permission-list-title{
                                display: flex;
                                align-items: center;
                                justify-content: space-between;
                                border-bottom: 1px solid ${({ theme }) => theme.mainBorderColor};
                                padding-block: 20px;
                                p{
                                    font-size: var(--font-size-sm);
                                    font-weight: var(--font-weight-lg);
                                }
                                .actions{
                                    display: flex;
                                    align-items: center;
                                    gap: 20px;
                                }
                            }
                            .permission-list{
                                display: flex;
                                flex-direction: column;
                                .permission-title{
                                    display: flex;
                                    align-items: center;
                                    justify-content: space-between;
                                    border-bottom: 1px solid ${({ theme }) => theme.mainBorderColor};
                                    padding-block: 10px;
                                    p{
                                        font-size: var(--font-size-sm);
                                        font-weight: var(--font-weight-md);
                                    }
                                    .permission-check-container{
                                        width: 32%;
                                        display: flex;
                                        align-items: center;
                                        justify-content: space-between;
                                        padding-inline: 30px;
                                        .page-check{
                                            display: flex;
                                            justify-content: center;
                                            align-items: center;
                                            width: 30px;
                                            height: 30px;
                                            border-radius: 50%;
                                            border: 2px solid ${({ theme }) => theme.mainBorderColor};
                                            color: ${({ theme }) => theme.mainTextColor};
                                            cursor: pointer;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    .button-grp{
        width: 100%;
        display: flex;
        justify-content: center;
        margin-top: auto;
        padding: 30px;
        gap: 50px;
    }
`


const UpdateKullaniciRolYetkiModal = () => {
    const dispatch = useDispatch()
    const location = useLocation()

    const { lockScroll, unlockScroll } = useScrollLock();

    const {modalLocation } = useSelector(state => state.modal)
    const {claimList, selectedUser, userClaims, isLoadingGet} = useSelector(state => state.companyAuthorization)
    
    const [openedMenuItemId, setOpenedMenuItemId ] = useState(null)

    const [updatedAuthorizationList, setUpdatedAuthorizationList] = useState([])

    useEffect(() => {
        dispatch(getUserClaims(selectedUser.id))
    }, [selectedUser])

    useEffect(() => {
        dispatch(getAllClaims())
    }, [])

    useEffect(() => {
        setUpdatedAuthorizationList(claimList.map((item) => {
            return {
                ...item, 
                permission: item?.permission?.$values.map((perm) => {
                    return {
                        ...perm,
                        permissions: perm?.permissions?.$values.map((subPerm) => {
                            return {
                                ...subPerm
                            }
                        })
                    }
                })
            }
        }))
    }, [claimList])

    useEffect(() => {
        if (userClaims?.length > 0) {
          setUpdatedAuthorizationList((prevList) =>
            prevList.map((item) => {
              const matchedClaim = userClaims.find((claim) => claim.id === item.id);
              return {
                ...item,
                havePermission: matchedClaim?.havePermission || false,
                permission: item.permission.map((perm) => {
                  const matchedPerm = matchedClaim?.permission?.$values?.find(p => p.description === perm.description);
      
                  //! sub permissionsları sırala ve havePermissionı güncelle
                  const sortedPermissions = [...perm.permissions]
                    .map((subPerm) => {
                      const matchedSubPerm = matchedPerm?.permissions?.$values?.find(p => p.id === subPerm.id);
                      return {
                        ...subPerm,
                        havePermission: matchedSubPerm?.havePermission || false,
                      };
                    })
                    .sort((a, b) => {
                      const aIsView = a.name.endsWith("_view");
                      const bIsView = b.name.endsWith("_view");
                      if (aIsView && !bIsView) return -1;
                      if (!aIsView && bIsView) return 1;
                      return 0;
                    });
      
                  return {
                    ...perm,
                    permissions: sortedPermissions,
                  };
                }),
              };
            })
          );
        }
    }, [userClaims]);
      
    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    const handleMainPermissionToggle = (itemId) => {
        //! Tıklanan itemin id sine göre tüm permissionsları güncelle
        setUpdatedAuthorizationList((prevList) =>
            prevList.map((item) => item.id === itemId ? 
                {
                    ...item,
                    havePermission: !item.havePermission, //! Ana öğenin permission değerini değiştir
                    permission: item.permission.map((perm) => ({
                        ...perm,
                        permissions: perm.permissions.map((subPerm) => ({
                            ...subPerm,
                            havePermission: !item.havePermission, //! Alt öğelerdeki tüm permissions'ı güncelle
                        })),
                    })),
                } : item
            )
        );
    };

    
    const handleSubPermissionToggle = (itemId, permissionId, subPermissionId, titleId, permissionType) => {
        setUpdatedAuthorizationList((prevList) =>
            prevList.map((item) =>
                item.id === itemId
                    ? {
                        ...item,
                        permission: item.permission.map((perm) =>
                            perm.id === permissionId
                            ? {
                                ...perm,
                                permissions: perm.permissions.map((subPerm) => {
                                    if (permissionType.endsWith("_view")) {
                                        return subPerm.id === subPermissionId
                                            ? {
                                                    ...subPerm,
                                                    havePermission: !subPerm.havePermission,
                                                }
                                            : subPerm;
                                    }

                                    if (permissionType.endsWith("_action")) {
                                        return subPerm.name.includes(
                                            permissionType.replace("_action", "")
                                        ) 
                                            ? {
                                                    ...subPerm,
                                                    havePermission: !subPerm.havePermission,
                                                }
                                            : subPerm;
                                    }

                                    return subPerm;
                                }),
                            }
                            : perm
                        ),
                      }
                    : item
            )
        );
    };
    

    const handleSubmit = () => {
        const updatedData = {
            userId: selectedUser.id,
            claimIds: updatedAuthorizationList //! Tüm yetkileri dolaş ve sadece yetkili olanların idsini al
                .flatMap(item => 
                    item.permission
                        .flatMap(perm => 
                            perm.permissions
                                .filter(subPerm => subPerm.havePermission)
                                .map(subPerm => subPerm.id)
                        )
                )
        }
        dispatch(addClaims(updatedData))
    }
    
  return (
    <ModalContainer onClick={()=> dispatch(showModal(null))}>
    <div className="modal" onClick={(e) => {e.stopPropagation(); dispatch(handleActiveSelect(null))}}>
        <PageTopTitle title={`${selectedUser.userName} Yetkilendirme İşlemleri`}/>
        <div className="content">

            <div className="menu-list-container">
                <div className="menu-list">
                    {
                    isLoadingGet ? 
                        <SmallSpinner size={"40px"} color={"#fff"} bgColor={"#E85446"}/> 
                    :
                    updatedAuthorizationList.map((item) => (
                        <div className="menu-item">
                            <div className="menu-item-title" onClick={() => setOpenedMenuItemId(openedMenuItemId === item.id ? null : item.id)}>
                                <span>{item.name}</span>
                                <div className="check-container">
                                    <div className="title-check" onClick={(e) => {e.stopPropagation(); handleMainPermissionToggle(item.id)}}>
                                        {
                                            item.havePermission && <BsCheckLg />
                                        }
                                    </div>
                                </div>
                        </div>
                            {openedMenuItemId === item.id && (
                                <div className="menu-item-content">
                                    <div className="permission-list-title">
                                        <p>Sayfalar</p>
                                        <div className="actions">
                                            <p>Görüntüleme</p>
                                            <p>İşlem Yapma</p>
                                        </div>
                                    </div>
                                    <div className="permission-list">
                                        {item.permission.map((permission) => (
                                            <div className="permission-title">
                                                <p>{permission.description}</p>
                                                <div className="permission-check-container">
                                                    {permission.permissions.map((perm) => (
                                                        <div  onClick={() => handleSubPermissionToggle(item.id, permission.id, perm.id, permission.$id, perm.name)} className="page-check">
                                                            {perm?.havePermission && <BsCheckLg />}
                                                        </div> 
                                                    ))}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
            
        </div>
        <div className="button-grp">
            <Btn bgColor={"transparent"} color={"#E85446"} width="280px" handleClick={handleSubmit}>Güncelle</Btn>
            <Btn bgColor={"#E85446"} color={"#fff"} width="280px" handleClick={() => {dispatch(showModal(null));}}>Kapat</Btn>
        </div>
    </div>
</ModalContainer>
  )
}

export default UpdateKullaniciRolYetkiModal    